import React, { HTMLProps } from 'react';
import { RobotFrownIcon } from '@navikt/aksel-icons';
import { Box, HelpText, Label, Popover } from '@navikt/ds-react';
import { store } from '@/app/_components/store/store';
import { hjelpetekstAriaLabel } from '@/utils/formatting/tekst';
import { css } from '@emotion/css';
import classNames from 'classnames';
import CheckAndPrint from 'components/check-and-print/CheckAndPrint';
interface AttributtMedIkonProps extends Pick<HTMLProps<HTMLDivElement>, 'className' | 'style'> {
  title?: string;
  data?: React.ReactElement | string | number | null;
  hjelpetekst?: React.ReactNode;
  feilmelding?: string | null;
  children?: string | React.ReactNode | React.ReactNode[];
  overskrift?: boolean;
  valgt?: boolean;
  icon?: typeof RobotFrownIcon;
}
const AttributtMedIkon = (props: AttributtMedIkonProps) => {
  const helptextRef = React.useRef(null);
  const {
    valgt,
    icon: Icon = RobotFrownIcon
  } = props;
  const {
    tekst
  } = store.useReducerState();
  const [popoverVisible, setPopoverVisible] = React.useState(false);
  return <Box className={classNames(css({
    display: 'flex',
    gap: 16,
    minHeight: '2.825em',
    '@media (max-width: 420px)': {
      width: '100%'
    }
  }), props.className)} style={props.style}>
            <Icon aria-hidden style={{
      minWidth: 48
    }} height="48px" />
            {/* min-width: 0 lar boksen krympe under lengste ord. Uten den presser lange sammensatte ord innholdet ut av skjermen ved tekstforstørring.
                break-word bryter kun ord som ikke får plass på egen linje, så navn holdes hele så lenge det er mulig. */}
            <Box className={css({
      minWidth: 0,
      overflowWrap: 'break-word'
    })}>
                <Label className={css({
        display: 'flex',
        alignItems: 'center',
        gap: 8
      })}>
                    <span {...!valgt && {
          onClick: () => setPopoverVisible(true),
          onMouseEnter: () => setPopoverVisible(true),
          onMouseLeave: () => setPopoverVisible(false)
        }} ref={helptextRef} className={css({
          opacity: props.valgt ? 1 : 0.35,
          cursor: !valgt ? 'help' : 'initial'
        })}>
                        {props.title}
                    </span>
                    {props.hjelpetekst && <HelpText title={hjelpetekstAriaLabel(tekst, props.title)}>{props.hjelpetekst}</HelpText>}
                </Label>
                <Popover anchorEl={helptextRef.current} open={popoverVisible} onClose={() => {
        setPopoverVisible(false);
      }} placement="bottom-start">
                    <div className={css({
          padding: 6
        })}>{tekst.info.opplysningIkkeValgt}</div>
                </Popover>
                <CheckAndPrint data={valgt ? props.data !== null && props.data !== undefined ? props.data : props.feilmelding || <div aria-label={tekst.info.ingenData}>{'—'}</div> : undefined} />
            </Box>
        </Box>;
};
export default AttributtMedIkon;